module.exports = __webpack_public_path__ + "static/kran02_450-50450523c3d55db0b44e949c191a171c.jpg";